import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || '';
const getToken = () => localStorage.getItem('notes_token') || '';
const apiFetch = async (url, opts = {}) => {
  const token = getToken();
  if (token && !opts.headers) opts.headers = {};
  if (token) opts.headers['x-token'] = token;
  const res = await fetch(url, opts);
  if (res.status === 401) {
    const data = await res.json().catch(() => ({}));
    if (data.error === '登录超时，请重新登录') {
      localStorage.removeItem('notes_token');
      localStorage.removeItem('notes_user');
      alert('登录超时，请重新登录');
      window.location.href = '/';
      return null;
    }
  }
  return res;
};

export default function WorkorderImport() {
  const navigate = useNavigate();
  const [projects, setProjects] = useState([]);
  const [projectCodes, setProjectCodes] = useState({}); // name → code
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
  const [chatText, setChatText] = useState('');
  const [pendingOrders, setPendingOrders] = useState([]);
  const [parsing, setParsing] = useState(false);
  const [importing, setImporting] = useState(false);
  const [nicknameMap, setNicknameMap] = useState({});
  const [showNicknameModal, setShowNicknameModal] = useState(false);
  const [showMappingManager, setShowMappingManager] = useState(false);
  const [mappingSearch, setMappingSearch] = useState('');
  const [currentNickname, setCurrentNickname] = useState('');
  const [currentRealname, setCurrentRealname] = useState('');
  const [currentUnit, setCurrentUnit] = useState('');
  const [currentIsSolver, setCurrentIsSolver] = useState(false);
  const [enablePolish, setEnablePolish] = useState(false);
  const [projectSearch, setProjectSearch] = useState('');
  const [showProjectDrop, setShowProjectDrop] = useState(false);
  const [projectModuleTrees, setProjectModuleTrees] = useState({}); // { projectName: [modules] }
  const [moduleSearches, setModuleSearches] = useState({}); // {idx: searchStr}
  const [showModuleDrop, setShowModuleDrop] = useState({}); // {idx: bool}
  const [ocrLoading, setOcrLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [inputMode, setInputMode] = useState('text'); // 'text' 或 'image'
  const [chatType, setChatType] = useState('wechat'); // 'wechat' 或 'feishu'
  const [showFeishuUnitModal, setShowFeishuUnitModal] = useState(false);
  const [feishuPersons, setFeishuPersons] = useState([]); // [{ name, unit }]
  const [feishuMap, setFeishuMap] = useState({});
  const [feishuBatchUnit, setFeishuBatchUnit] = useState('');
  const [feishuBatchSearch, setFeishuBatchSearch] = useState('');
  const [feishuBatchDrop, setFeishuBatchDrop] = useState(false);
  const [projectUnits, setProjectUnits] = useState([]); // 当前项目的公司列表
  const [unitSearch, setUnitSearch] = useState('');
  const [showUnitDrop, setShowUnitDrop] = useState(false);
  const [qaContentSearches, setQaContentSearches] = useState({});
  const [showQaContentDrop, setShowQaContentDrop] = useState({});
  const [sysAdjustSearches, setSysAdjustSearches] = useState({});
  const [showSysAdjustDrop, setShowSysAdjustDrop] = useState({});
  const [orderUnitSearches, setOrderUnitSearches] = useState({}); // {idx: searchStr}
  const [showOrderUnitDrop, setShowOrderUnitDrop] = useState({}); // {idx: bool}
  const [orderUnitsCache, setOrderUnitsCache] = useState({}); // {projectCode: [units]}
  const worktimeOptions = ['5','10','30','60','90','120','150','180','210','240','270','300','360','420','480','540','600','660','720','780','840','900','1200','1500','2400']; // 工作时长下拉选项（固定值）
  const [worktimeSearches, setWorktimeSearches] = useState({}); // {idx: searchStr}
  const [showWorktimeDrop, setShowWorktimeDrop] = useState({}); // {idx: bool}

  // 加载项目列表
  useEffect(() => {
    apiFetch(`${API_URL}/api/workorder/projects`)
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          setProjects(data.projects || []);
          setProjectCodes(data.projectCodes || {});
          // 直接使用API返回的modules（项目名→模块树）
          if (data.modules) {
            setProjectModuleTrees(data.modules);
            console.log('已加载项目模块:', Object.keys(data.modules).length, '个');
          }
        }
      })
      .catch(console.error);
    
    // 加载昵称映射
    apiFetch(`${API_URL}/api/workorder-import/nickname-map`)
      .then(r => r.json())
      .then(data => {
        if (data.success) setNicknameMap(data.map || {});
      })
      .catch(console.error);
    
    // 加载飞书映射
    apiFetch(`${API_URL}/api/workorder-import/feishu-unit-map`)
      .then(r => r.json())
      .then(data => {
        if (data.success) setFeishuMap(data.map || {});
      })
      .catch(console.error);
    
  }, []);

  // 项目变化时加载关联公司列表
  useEffect(() => {
    if (!selectedProject) { setProjectUnits([]); return; }
    const code = projectCodes[selectedProject];
    if (!code) return;
    apiFetch(`${API_URL}/api/workorder-import/project-units/${code}`)
      .then(r => r.json())
      .then(data => {
        if (data.success) setProjectUnits(data.units || []);
      })
      .catch(console.error);
  }, [selectedProject, projectCodes]);


  // 解析成功后，加载工单项目的模块树
  const loadModulesForProjects = async (projectNames, codesMap) => {
    for (const projectName of projectNames) {
      const code = codesMap[projectName] || projectCodes[projectName];
      if (!code) continue;
      
      try {
        const res = await apiFetch(`${API_URL}/api/workorder-import/project-modules/${code}`);
        const data = await res.json();
        if (data.success) {
          setProjectModuleTrees(prev => ({ ...prev, [projectName]: data.tree || [] }));
        }
      } catch (e) {
        console.error('加载模块失败:', projectName, e);
      }
    }
  };

  // 解析聊天记录
  const handleParse = async () => {
    if (!chatText.trim()) {
      alert('请粘贴聊天记录');
      return;
    }
    if (!selectedProject) {
      alert('请选择项目');
      return;
    }
    
    setParsing(true);
    try {
      const res = await apiFetch(`${API_URL}/api/workorder-import/parse`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          text: chatText,
          project: selectedProject,
          date: selectedDate,
          nicknameMap,
          enablePolish,
          chatType
        })
      });
      const data = await res.json();
      
      // 飞书模式：未设置单位的人员
      if (data.unmappedFeishuPersons && data.unmappedFeishuPersons.length > 0) {
        setFeishuPersons(data.unmappedFeishuPersons.map(n => ({ name: n, unit: feishuMap[n]?.unit || '' })));
        setShowFeishuUnitModal(true);
        setParsing(false);
        return;
      }
      
      // 微信模式：未映射的昵称
      if (data.unmappedNicknames && data.unmappedNicknames.length > 0) {
        const nick = data.unmappedNicknames[0];
        setCurrentNickname(nick);
        setCurrentRealname('');
        setCurrentUnit('');
        setCurrentIsSolver(false);
        setShowNicknameModal(true);
        setParsing(false);
        return;
      }
      
      if (data.success) {
        const newOrders = data.orders || (data.order ? [data.order] : []);
        // 给每个工单添加orderSource（默认跟随chatType）
        const ordersWithSource = newOrders.map(o => ({ ...o, orderSource: chatType === 'feishu' ? '飞书' : '微信' }));
        setPendingOrders(prev => [...prev, ...ordersWithSource]);
        setChatText('');
        // 加载新工单的模块树和公司列表
        const newProjects = [...new Set(ordersWithSource.map(o => o.project).filter(Boolean))];
        loadModulesForProjects(newProjects, data.projectCodes || projectCodes);
        loadUnitsForProjects(newProjects, data.projectCodes || projectCodes);
        alert('解析成功，已添加 ' + ordersWithSource.length + ' 条工单');
      } else {
        alert(data.error || '解析失败');
      }
    } catch (e) {
      alert('网络错误');
    }
    setParsing(false);
  };

  // 加载工单项目的公司列表
  const loadUnitsForProjects = async (projectNames, codesMap) => {
    for (const projectName of projectNames) {
      const code = codesMap[projectName] || projectCodes[projectName];
      if (!code || orderUnitsCache[code]) continue;
      try {
        const res = await apiFetch(`${API_URL}/api/workorder-import/project-units/${code}`);
        const data = await res.json();
        if (data.success) {
          setOrderUnitsCache(prev => ({ ...prev, [code]: data.units || [] }));
        }
      } catch (e) {
        console.error('加载公司列表失败:', projectName, e);
      }
    }
  };

  // 获取工单的公司列表
  const getOrderUnits = (orderProject) => {
    const code = projectCodes[orderProject];
    return orderUnitsCache[code] || [];
  };

  // 保存昵称映射
  // 截图识别
  const handleOCR = async (file) => {
    if (!file) return;
    setOcrLoading(true);
    const formData = new FormData();
    formData.append('image', file);
    try {
      const res = await apiFetch(`${API_URL}/api/workorder-import/ocr`, {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data.success && data.text) {
        setChatText(data.text);
        setSelectedImage(null);
        setInputMode('text'); // 自动切换到文字模式
        alert('识别成功，已填入聊天记录');
      } else {
        alert(data.error || '识别失败');
      }
    } catch (e) {
      alert('网络错误');
    }
    setOcrLoading(false);
  };

  // 全局粘贴监听
  useEffect(() => {
    const handleGlobalPaste = (e) => {
      if (inputMode !== 'image') return;
      const items = e.clipboardData?.items;
      if (!items) return;
      for (const item of items) {
        if (item.type.startsWith('image/')) {
          e.preventDefault();
          const file = item.getAsFile();
          setSelectedImage(file);
          break;
        }
      }
    };
    document.addEventListener('paste', handleGlobalPaste);
    return () => document.removeEventListener('paste', handleGlobalPaste);
  }, [inputMode]);

  // 保存飞书单位批量设置
  const handleSaveFeishuUnits = async () => {
    try {
      await apiFetch(`${API_URL}/api/workorder-import/feishu-unit-map/batch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ mappings: feishuPersons.filter(p => p.unit) })
      });
      const newMap = { ...feishuMap };
      for (const p of feishuPersons) {
        if (p.unit) newMap[p.name] = { unit: p.unit };
      }
      setFeishuMap(newMap);
      setShowFeishuUnitModal(false);
      // 重新解析
      handleParse();
    } catch (e) {
      alert('保存失败');
    }
  };

  // 保存昵称映射
  const handleSaveNickname = async () => {
    if (!currentRealname.trim()) {
      alert('请输入真实姓名');
      return;
    }
    
    const newMap = {
      ...nicknameMap,
      [currentNickname]: {
        realname: currentRealname,
        unit: currentUnit,
        isSolver: currentIsSolver
      }
    };
    
    try {
      await apiFetch(`${API_URL}/api/workorder-import/nickname-map`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nickname: currentNickname, realname: currentRealname, unit: currentUnit, isSolver: currentIsSolver })
      });
      setNicknameMap(newMap);
    } catch (e) {
      console.error(e);
    }
    
    setShowNicknameModal(false);
    // 重新解析
    handleParse();
  };

  // 删除待导入工单
  const handleRemoveOrder = (index) => {
    setPendingOrders(prev => prev.filter((_, i) => i !== index));
  };

  // 修改工单字段
  const handleUpdateOrder = (index, field, value) => {
    setPendingOrders(prev => prev.map((order, i) =>
      i === index ? { ...order, [field]: value } : order
    ));
  };

  // 批量导入
  const handleImport = async () => {
    if (pendingOrders.length === 0) {
      alert('没有待导入的工单');
      return;
    }
    
    if (!window.confirm(`确定导入 ${pendingOrders.length} 条工单？`)) return;
    
    setImporting(true);
    try {
      const res = await apiFetch(`${API_URL}/api/workorder-import/batch`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orders: pendingOrders })
      });
      const data = await res.json();
      if (data.success) {
        alert(`成功导入 ${data.successCount} 条工单`);
        setPendingOrders([]);
      } else {
        alert(data.error || '导入失败');
      }
    } catch (e) {
      alert('网络错误');
    }
    setImporting(false);
  };

  // 服务类型选项
  const serviceTypes = ['答疑', '系统调整', '数据导出', '开发处理', 'BUG处理', '数据备份', '文档编写', '基础环境运维'];
  
  // 工单类型选项
  const orderTypes = ['应用运维', '技术运维', '受理新需求', '增值服务'];

  // 模块树扁平化（递归）
  const flattenModules = (nodes, depth = 0) => {
    const result = [];
    for (const node of (nodes || [])) {
      result.push({ label: node.label, id: node.id, depth });
      if (node.children) result.push(...flattenModules(node.children, depth + 1));
    }
    return result;
  };

  // 获取某个工单的模块树（按项目）
  const getFlatModules = (projectName) => flattenModules(projectModuleTrees[projectName] || []);

  // 过滤模块
  const getFilteredModules = (projectName, searchStr) => {
    const flat = getFlatModules(projectName);
    if (!searchStr) return flat;
    const s = searchStr.toLowerCase();
    return flat.filter(m => m.label.toLowerCase().includes(s));
  };

  return (
    <div className="workorder-import-page">
      <div className="woi-header">
        <button onClick={() => navigate('/')} className="btn-back">← 返回首页</button>
        <h2>📝 工单录入</h2>
        <button onClick={() => setShowMappingManager(true)} className="btn-mapping-manager">映射管理</button>
      </div>

      <div className="woi-layout">
        {/* 左侧：输入区 */}
        <div className="woi-input-section">
          <div className="woi-config">
            <div className="form-group">
              <label>项目 *</label>
              <div className="project-select-wrapper">
                <input
                  type="text"
                  value={projectSearch || selectedProject}
                  onChange={(e) => {
                    setProjectSearch(e.target.value);
                    setSelectedProject('');
                    setShowProjectDrop(true);
                  }}
                  onFocus={() => setShowProjectDrop(true)}
                  placeholder="搜索项目..."
                  className="form-input"
                />
                {showProjectDrop && (
                  <div className="project-dropdown">
                    {projects.filter(p => p.toLowerCase().includes((projectSearch || '').toLowerCase())).slice(0, 10).map(p => (
                      <div key={p} className="project-option" onClick={() => {
                        setSelectedProject(p);
                        setProjectSearch(p);
                        setShowProjectDrop(false);
                      }}>{p}</div>
                    ))}
                    {projects.filter(p => p.toLowerCase().includes((projectSearch || '').toLowerCase())).length === 0 && <div className="project-empty">无匹配项目</div>}
                  </div>
                )}
              </div>
            </div>
            <div className="form-group">
              <label>日期 *</label>
              <input type="date" value={selectedDate} onChange={(e) => setSelectedDate(e.target.value)} className="form-input" />
            </div>
          </div>

          {/* 输入模式切换 - 重设计 */}
          <div className="woi-input-section">
            <div className="woi-input-header">
              <div className="woi-source-tabs">
                <span className="woi-source-label">来源：</span>
                <button className={chatType === 'wechat' ? 'woi-source-btn active' : 'woi-source-btn'} onClick={() => setChatType('wechat')}>微信</button>
                <button className={chatType === 'feishu' ? 'woi-source-btn active' : 'woi-source-btn'} onClick={() => setChatType('feishu')}>飞书</button>
              </div>
              <div className="woi-mode-pills">
                <button className={inputMode === 'text' ? 'woi-pill active' : 'woi-pill'} onClick={() => setInputMode('text')}>📝 文字</button>
                <button className={inputMode === 'image' ? 'woi-pill active' : 'woi-pill'} onClick={() => setInputMode('image')}>📷 截图</button>
              </div>
            </div>

            {inputMode === 'text' ? (
              <div className="woi-chat-input">
                <label>粘贴聊天记录</label>
                <textarea
                  value={chatText}
                  onChange={(e) => setChatText(e.target.value)}
                  placeholder={`粘贴格式示例：
张三:
固定资产卡片折旧不对

李四:
哪个项目的？

张三:
北汽集团`}
                  rows={12}
                />
              </div>
            ) : (
              <div className="woi-image-mode">
                <input id="ocr-file-input" type="file" accept="image/*" style={{ display: 'none' }}
                  onChange={e => setSelectedImage(e.target.files[0])} />
                {selectedImage ? (
                  <div className="woi-image-preview-box">
                    <img src={URL.createObjectURL(selectedImage)} alt="预览" className="woi-image-thumb" />
                    <div className="woi-image-actions-box">
                      <div style={{marginBottom: '8px', color: '#374151', fontSize: '14px'}}>👆 图片已粘贴，点击识别</div>
                      <div className="woi-image-actions">
                        <button onClick={() => handleOCR(selectedImage)} disabled={ocrLoading} className="btn-ocr">
                          {ocrLoading ? '🔍 识别中...' : '✅ 识别并填入'}
                        </button>
                        <button onClick={() => setSelectedImage(null)} className="btn-ocr-cancel">
                          取消
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="woi-image-dropzone" onClick={() => document.getElementById('ocr-file-input').click()}>
                    <div className="woi-dropzone-icon">📷</div>
                    <div className="woi-dropzone-text">Ctrl+V 粘贴截图 或 点击上传</div>
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="polish-toggle">
            <label className="checkbox-label">
              <input type="checkbox" checked={enablePolish} onChange={(e) => setEnablePolish(e.target.checked)} />
              <span>AI润色（关闭可加快速度）</span>
            </label>
          </div>

          <button onClick={handleParse} className="btn-primary btn-parse" disabled={parsing}>
            {parsing ? '解析中...' : '解析并添加'}
          </button>
        </div>

        {/* 右侧：待导入列表 */}
        <div className="woi-pending-section">
          <div className="woi-pending-header">
            <h3>待导入工单 ({pendingOrders.length}条)</h3>
            {pendingOrders.length > 0 && (
              <button onClick={handleImport} className="btn-primary" disabled={importing}>
                {importing ? '导入中...' : '确认导入'}
              </button>
            )}
          </div>

          {pendingOrders.length === 0 ? (
            <div className="woi-empty">暂无待导入工单，请先粘贴聊天记录</div>
          ) : (
            <div className="woi-order-list">
              {pendingOrders.map((order, idx) => (
                <div key={idx} className="woi-order-card">
                  <div className="woi-order-header">
                    <span className="woi-order-num">#{idx + 1}</span>
                    <button className="btn-remove" onClick={() => handleRemoveOrder(idx)}>✕</button>
                  </div>
                  <div className="woi-order-body">
                    <div className="woi-field">
                      <label>提问人</label>
                      <input value={order.realname} onChange={(e) => handleUpdateOrder(idx, 'realname', e.target.value)} className="form-input" />
                    </div>
                    <div className="woi-field">
                      <label>所属单位</label>
                      {(() => {
                        const units = getOrderUnits(order.project);
                        if (units.length === 0) {
                          return <input value={order.unit || ''} onChange={(e) => handleUpdateOrder(idx, 'unit', e.target.value)} className="form-input" placeholder="输入所属单位" />;
                        }
                        return (
                          <div className="fuzzy-select-wrapper">
                            <input
                              value={orderUnitSearches[idx] !== undefined ? orderUnitSearches[idx] : (order.unit || '')}
                              onChange={(e) => { setOrderUnitSearches(p => ({...p, [idx]: e.target.value})); setShowOrderUnitDrop(p => ({...p, [idx]: true})); handleUpdateOrder(idx, 'unit', e.target.value); }}
                              onFocus={() => setShowOrderUnitDrop(p => ({...p, [idx]: true}))}
                              className="form-input"
                              placeholder="搜索所属单位..."
                            />
                            {showOrderUnitDrop[idx] && (
                              <div className="fuzzy-select-dropdown">
                                {units
                                  .filter(u => orderUnitSearches[idx] === undefined || !orderUnitSearches[idx] || u.unitName.includes(orderUnitSearches[idx]) || u.shortName.includes(orderUnitSearches[idx]))
                                  .map(u => (
                                    <div key={u.unit} className="fuzzy-select-option"
                                      onMouseDown={() => { handleUpdateOrder(idx, 'unit', u.unitName); const np = {...orderUnitSearches}; delete np[idx]; setOrderUnitSearches(np); setShowOrderUnitDrop(p => ({...p, [idx]: false})); }}>
                                      {u.unitName}
                                    </div>
                                  ))
                                }
                              </div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                    <div className="woi-field full">
                      <label>问题描述</label>
                      <textarea value={order.question} onChange={(e) => handleUpdateOrder(idx, 'question', e.target.value)} rows={2} />
                    </div>
                    <div className="woi-field full">
                      <label>解决方案</label>
                      <textarea value={order.solution || ''} onChange={(e) => handleUpdateOrder(idx, 'solution', e.target.value)} rows={2} />
                    </div>
                                        <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
                      <div className="woi-field" style={{ flex: 1 }}>
                        <label>答疑内容</label>
                        <div className="fuzzy-select-wrapper">
                          <input
                            value={qaContentSearches[idx] !== undefined ? qaContentSearches[idx] : (order.qaContent || '')}
                            onChange={(e) => {
                              setQaContentSearches(p => ({...p, [idx]: e.target.value }));
                              setShowQaContentDrop(p => ({...p, [idx]: true }));
                              handleUpdateOrder(idx, 'qaContent', e.target.value);
                            }}
                            onFocus={() => setShowQaContentDrop(p => ({...p, [idx]: true }))}
                            className="form-input"
                            placeholder="答疑内容..."
                          />
                          {showQaContentDrop[idx] && (
                            <div className="fuzzy-select-dropdown">
                              {['系统操作指导', '数据核对', '用户登录', '系统配置', '系统接口', '系统开发', '运维管理流程']
                                .filter(opt => !qaContentSearches[idx] || opt.includes(qaContentSearches[idx]))
                                .map(opt => (
                                  <div key={opt} className="fuzzy-select-option"
                                    onMouseDown={() => {
                                      handleUpdateOrder(idx, 'qaContent', opt);
                                      const np = {...qaContentSearches};
                                      delete np[idx];
                                      setQaContentSearches(np);
                                      setShowQaContentDrop(p => ({...p, [idx]: false }));
                                    }}>
                                    {opt}
                                  </div>
                                ))
                              }
                              {['系统操作指导', '数据核对', '用户登录', '系统配置', '系统接口', '系统开发', '运维管理流程']
                                .filter(opt => !qaContentSearches[idx] || opt.includes(qaContentSearches[idx])).length === 0 && (
                                <div className="fuzzy-select-option" style={{ color: '#999' }}
                                  onMouseDown={() => { setShowQaContentDrop(p => ({...p, [idx]: false })); }}>
                                  无匹配（可自行输入）
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="woi-field" style={{ flex: 1 }}>
                        <label>系统调整内容</label>
                        <div className="fuzzy-select-wrapper">
                          <input
                            value={sysAdjustSearches[idx] !== undefined ? sysAdjustSearches[idx] : (order.sysAdjust || '')}
                            onChange={(e) => {
                              setSysAdjustSearches(p => ({...p, [idx]: e.target.value }));
                              setShowSysAdjustDrop(p => ({...p, [idx]: true }));
                              handleUpdateOrder(idx, 'sysAdjust', e.target.value);
                            }}
                            onFocus={() => setShowSysAdjustDrop(p => ({...p, [idx]: true }))}
                            className="form-input"
                            placeholder="调整内容..."
                          />
                          {showSysAdjustDrop[idx] && (
                            <div className="fuzzy-select-dropdown">
                              {['集团报表', '权限', '主数据', '审批流', '单据模板', '打印模板', '报表', '业务参数', '数据库表', 'sysconfig', '会计平台', '打补丁', '重启服务', '重启服务器', '预制报表', '重建搜索', '业务规则', '企业报表', '预算套表', 'OA接口', '业务系统接口', '协议配置', '重置密码/账号解锁']
                                .filter(opt => !sysAdjustSearches[idx] || opt.includes(sysAdjustSearches[idx]))
                                .map(opt => (
                                  <div key={opt} className="fuzzy-select-option"
                                    onMouseDown={() => {
                                      handleUpdateOrder(idx, 'sysAdjust', opt);
                                      const np = {...sysAdjustSearches};
                                      delete np[idx];
                                      setSysAdjustSearches(np);
                                      setShowSysAdjustDrop(p => ({...p, [idx]: false }));
                                    }}>
                                    {opt}
                                  </div>
                                ))
                              }
                              {['集团报表', '权限', '主数据', '审批流', '单据模板', '打印模板', '报表', '业务参数', '数据库表', 'sysconfig', '会计平台', '打补丁', '重启服务', '重启服务器', '预制报表', '重建搜索', '业务规则', '企业报表', '预算套表', 'OA接口', '业务系统接口', '协议配置', '重置密码/账号解锁']
                                .filter(opt => !sysAdjustSearches[idx] || opt.includes(sysAdjustSearches[idx])).length === 0 && (
                                <div className="fuzzy-select-option" style={{ color: '#999' }}
                                  onMouseDown={() => { setShowSysAdjustDrop(p => ({...p, [idx]: false })); }}>
                                  无匹配（可自行输入）
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div><div className="woi-field">
                      <label>对应模块</label>
                      {(() => {
                        const tree = projectModuleTrees[order.project] || [];
                        const flatMods = flattenModules(tree);
                        // 有模块配置且数量>1，显示下拉
                        if (flatMods.length > 1) {
                          return (
                            <div className="module-select-wrapper">
                              <input
                                value={moduleSearches[idx] ?? order.module ?? ''}
                                onChange={(e) => {
                                  setModuleSearches(prev => ({ ...prev, [idx]: e.target.value }));
                                  setShowModuleDrop(prev => ({ ...prev, [idx]: true }));
                                }}
                                onFocus={() => setShowModuleDrop(prev => ({ ...prev, [idx]: true }))}
                                placeholder="搜索模块..."
                                className="form-input"
                              />
                              {showModuleDrop[idx] && (
                                <div className="module-dropdown">
                                  {getFilteredModules(order.project, moduleSearches[idx] || '').map(m => (
                                    <div
                                      key={m.id}
                                      className="module-option"
                                      style={{ paddingLeft: 8 + m.depth * 16 }}
                                      onClick={() => {
                                        handleUpdateOrder(idx, 'module', m.label);
                                        setModuleSearches(prev => {
                                          const ns = { ...prev };
                                          delete ns[idx];
                                          return ns;
                                        });
                                        setShowModuleDrop(prev => ({ ...prev, [idx]: false }));
                                      }}
                                    >
                                      {m.label}
                                    </div>
                                  ))}
                                  {getFilteredModules(order.project, moduleSearches[idx] || '').length === 0 && (
                                    <div className="project-empty">无匹配模块</div>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        }
                        // 单模块或无模块配置，显示输入框（后端已匹配）
                        return <input value={order.module || ''} onChange={(e) => handleUpdateOrder(idx, 'module', e.target.value)} className="form-input" placeholder={flatMods.length === 1 ? flatMods[0].label : "(自动匹配)"} />;
                      })()}
                    </div>
                    {/* 邢台项目 - 平台端口 */}
                    {order.project === '邢台燃气用户服务平台开发' && (
                      <div className="woi-field">
                        <label>平台端口</label>
                        <select value={order.platform || ''} onChange={(e) => handleUpdateOrder(idx, 'platform', e.target.value)} className="form-select">
                          <option value="">请选择</option>
                          <option value="PC端">PC端</option>
                          <option value="呼叫中心">呼叫中心</option>
                          <option value="小程序-用户">小程序-用户</option>
                          <option value="小程序-员工">小程序-员工</option>
                        </select>
                      </div>
                    )}
                    <div className="woi-field">
                      <label>服务类型</label>
                      <select value={order.serviceType} onChange={(e) => handleUpdateOrder(idx, 'serviceType', e.target.value)} className="form-select">
                        {serviceTypes.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="woi-field">
                      <label>工单类型</label>
                      <select value={order.orderType} onChange={(e) => handleUpdateOrder(idx, 'orderType', e.target.value)} className="form-select">
                        {orderTypes.map(t => <option key={t} value={t}>{t}</option>)}
                      </select>
                    </div>
                    <div className="woi-field">
                      <label>工单来源</label>
                      <select value={order.orderSource || '微信'} onChange={(e) => handleUpdateOrder(idx, 'orderSource', e.target.value)} className="form-select">
                        <option value="微信">微信</option>
                        <option value="飞书">飞书</option>
                      </select>
                    </div>
                    {/* 工作时长 */}
                    {worktimeOptions.length > 0 && (
                      <div className="woi-field">
                        <label>工作时长(分钟)</label>
                        <div className="fuzzy-select-wrapper">
                          <input
                            value={worktimeSearches[idx] !== undefined ? worktimeSearches[idx] : (order.worktime || '')}
                            onChange={(e) => {
                              setWorktimeSearches(p => ({...p, [idx]: e.target.value}));
                              setShowWorktimeDrop(p => ({...p, [idx]: true}));
                              handleUpdateOrder(idx, 'worktime', e.target.value);
                            }}
                            onFocus={() => setShowWorktimeDrop(p => ({...p, [idx]: true}))}
                            className="form-input"
                            placeholder="选择或输入分钟数..."
                          />
                          {showWorktimeDrop[idx] && (
                            <div className="fuzzy-select-dropdown">
                              {worktimeOptions
                                .filter(opt => !worktimeSearches[idx] || opt.includes(worktimeSearches[idx]))
                                .map(opt => (
                                  <div key={opt} className="fuzzy-select-option"
                                    onMouseDown={() => {
                                      handleUpdateOrder(idx, 'worktime', opt);
                                      const np = {...worktimeSearches};
                                      delete np[idx];
                                      setWorktimeSearches(np);
                                      setShowWorktimeDrop(p => ({...p, [idx]: false}));
                                    }}>
                                    {opt}
                                  </div>
                                ))
                              }
                              {worktimeOptions
                                .filter(opt => !worktimeSearches[idx] || opt.includes(worktimeSearches[idx])).length === 0 && (
                                <div className="fuzzy-select-option" style={{ color: '#999' }}
                                  onMouseDown={() => { setShowWorktimeDrop(p => ({...p, [idx]: false})); }}>
                                  无匹配（可自行输入）
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* 昵称映射弹窗 */}
      {showNicknameModal && (
        <div className="modal-overlay">
          <div className="modal-content nickname-modal">
            <h3>配置昵称映射</h3>
            <p className="modal-hint">首次遇到该微信昵称，请配置对应的真实姓名和所属单位</p>
            <div className="form-group">
              <label>微信昵称</label>
              <input value={currentNickname} disabled className="form-input" />
            </div>
            <div className="form-group">
              <label>真实姓名 *</label>
              <input value={currentRealname} onChange={(e) => setCurrentRealname(e.target.value)} className="form-input" placeholder="输入真实姓名" />
            </div>
            <div className="form-group">
              <label>所属单位</label>
              <div className="fuzzy-select-wrapper">
                <input
                  value={unitSearch || currentUnit}
                  onChange={(e) => { setUnitSearch(e.target.value); setShowUnitDrop(true); setCurrentUnit(e.target.value); }}
                  onFocus={() => setShowUnitDrop(true)}
                  className="form-input"
                  placeholder="搜索所属单位..."
                />
                {showUnitDrop && projectUnits.length > 0 && (
                  <div className="fuzzy-select-dropdown">
                    {projectUnits
                      .filter(u => !unitSearch || u.unitName.includes(unitSearch) || u.shortName.includes(unitSearch))
                      .map(u => (
                        <div key={u.unit} className="fuzzy-select-option"
                          onMouseDown={() => { setCurrentUnit(u.unitName); setUnitSearch(''); setShowUnitDrop(false); }}>
                          {u.unitName}
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>
            </div>
            <div className="form-group checkbox-group">
              <label className="checkbox-label">
                <input type="checkbox" checked={currentIsSolver} onChange={(e) => setCurrentIsSolver(e.target.checked)} />
                <span>此人是运维顾问</span>
              </label>
            </div>
            <div className="modal-actions">
              <button onClick={handleSaveNickname} className="btn-primary">保存</button>
              <button onClick={() => setShowNicknameModal(false)} className="btn-secondary">取消</button>
            </div>
          </div>
        </div>
      )}
      {/* 飞书单位设置弹窗 */}
      {showFeishuUnitModal && (
        <div className="modal-overlay" onClick={() => setShowFeishuUnitModal(false)}>
          <div className="modal-content feishu-unit-modal" onClick={e => e.stopPropagation()}>
            <div className="feishu-modal-header">
              <h3>📱 飞书人员单位设置</h3>
              <p className="modal-hint">以下人员未设置所属单位，请选择或搜索单位</p>
            </div>
            {/* 批量设置 */}
            <div className="feishu-batch-row">
              <span className="feishu-batch-label">批量设置同一单位：</span>
              <div className="fuzzy-select-wrapper feishu-batch-select">
                <input
                  value={feishuBatchSearch || feishuBatchUnit}
                  onChange={e => { setFeishuBatchSearch(e.target.value); setFeishuBatchUnit(e.target.value); setFeishuBatchDrop(true); }}
                  onFocus={() => setFeishuBatchDrop(true)}
                  className="form-input"
                  placeholder="搜索单位..."
                />
                {feishuBatchDrop && projectUnits.length > 0 && (
                  <div className="fuzzy-select-dropdown">
                    {projectUnits
                      .filter(u => !feishuBatchSearch || u.unitName.includes(feishuBatchSearch) || u.shortName.includes(feishuBatchSearch))
                      .map(u => (
                        <div key={u.unit} className="fuzzy-select-option"
                          onMouseDown={() => { setFeishuBatchUnit(u.unitName); setFeishuBatchSearch(''); setFeishuBatchDrop(false); setFeishuPersons(prev => prev.map(p => ({...p, unit: u.unitName, unitSearch: undefined, showDrop: false}))); }}>
                          {u.unitName}
                        </div>
                      ))
                    }
                  </div>
                )}
              </div>
              <button className="btn-apply-batch" onClick={() => {
                if (feishuBatchUnit) {
                  setFeishuPersons(prev => prev.map(p => ({...p, unit: feishuBatchUnit, unitSearch: undefined, showDrop: false})));
                }
              }}>应用全部</button>
            </div>
            <div className="feishu-persons-list">
              {feishuPersons.map((p, idx) => (
                <div key={p.name} className="feishu-person-item">
                  <span className="feishu-person-name">{p.name}</span>
                  <div className="fuzzy-select-wrapper">
                    <input
                      value={p.unitSearch !== undefined ? p.unitSearch : p.unit}
                      onChange={e => setFeishuPersons(prev => prev.map((pp, i) => i===idx ? {...pp, unitSearch: e.target.value, unit: e.target.value, showDrop: true} : pp))}
                      onFocus={() => setFeishuPersons(prev => prev.map((pp, i) => i===idx ? {...pp, showDrop: true} : pp))}
                      onBlur={() => setTimeout(() => setFeishuPersons(prev => prev.map((pp, i) => i===idx ? {...pp, showDrop: false} : pp)), 200)}
                      className="form-input feishu-unit-input"
                      placeholder="搜索单位..."
                    />
                    {(p.showDrop && projectUnits.length > 0) && (
                      <div className="fuzzy-select-dropdown">
                        {projectUnits
                          .filter(u => p.unitSearch === undefined || !p.unitSearch || u.unitName.includes(p.unitSearch) || u.shortName.includes(p.unitSearch))
                          .map(u => (
                            <div key={u.unit} className="fuzzy-select-option"
                              onMouseDown={() => setFeishuPersons(prev => prev.map((pp, i) => i===idx ? {...pp, unit: u.unitName, unitSearch: undefined, showDrop: false} : pp))}>
                              {u.unitName}
                            </div>
                          ))
                        }
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div className="modal-actions">
              <button onClick={handleSaveFeishuUnits} className="btn-primary">✅ 保存并继续解析</button>
              <button onClick={() => setShowFeishuUnitModal(false)} className="btn-secondary">取消</button>
            </div>
          </div>
        </div>
      )}
      {/* 映射管理弹窗 */}
      {showMappingManager && (
        <div className="modal-overlay">
          <div className="modal-content mapping-manager-modal">
            <div className="mapping-header">
              <h3>映射管理</h3>
              <button onClick={() => { setShowMappingManager(false); setMappingSearch(''); }} className="btn-close">✕</button>
            </div>
            <div className="mapping-search-bar">
              <input
                type="text"
                placeholder="搜索昵称或姓名..."
                value={mappingSearch}
                onChange={e => setMappingSearch(e.target.value)}
                className="mapping-search-input"
                autoFocus
              />
              {mappingSearch && (
                <button className="mapping-search-clear" onClick={() => setMappingSearch('')}>✕</button>
              )}
            </div>
            {Object.keys(nicknameMap).length === 0 ? (
              <div className="mapping-empty">暂无映射记录</div>
            ) : (
              (() => {
                const filtered = Object.entries(nicknameMap).filter(([nick, info]) => {
                  const q = mappingSearch.toLowerCase();
                  if (!q) return true;
                  return nick.toLowerCase().includes(q) || info.realname.toLowerCase().includes(q);
                });
                return filtered.length === 0 ? (
                  <div className="mapping-empty">没有匹配的映射记录</div>
                ) : (
                  <div className="mapping-list">
                    {filtered.map(([nick, info]) => (
                      <div key={nick} className="mapping-item">
                        <div className="mapping-info">
                          <span className="mapping-nick" title={nick}>{nick}</span>
                          <span className="mapping-arrow">→</span>
                          <span className="mapping-realname">{info.realname}</span>
                          {info.unit && <span className="mapping-unit">（{info.unit}）</span>}
                          {info.isSolver && <span className="badge-solver">顾问</span>}
                        </div>
                        <div className="mapping-actions">
                          <button className="btn-edit" onClick={() => {
                            setCurrentNickname(nick);
                            setCurrentRealname(info.realname);
                            setCurrentUnit(info.unit || '');
                            setCurrentIsSolver(info.isSolver || false);
                            setShowMappingManager(false);
                            setShowNicknameModal(true);
                          }}>编辑</button>
                          <button className="btn-delete" onClick={async () => {
                            if (!window.confirm('确认删除该映射？')) return;
                            try {
                              await apiFetch(`${API_URL}/api/workorder-import/nickname-map/${encodeURIComponent(nick)}`, { method: 'DELETE' });
                              const res = await apiFetch(`${API_URL}/api/workorder-import/nickname-map`);
                              const data = await res.json();
                              if (data.success) setNicknameMap(data.map);
                            } catch (e) { alert('删除失败'); }
                          }}>删除</button>
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()
            )}
          </div>
        </div>
      )}
    </div>
  );
}
